(() => {
  const utils = window.ThemeSwiperUtils;
  if (!utils) return;

  utils.registerSectionSlider({
    key: 'brewing-instructions-slider',
    selectors: {
      sliderContainer: '[data-brewing-instructions-slider]',
      swiperContainer: '[data-brewing-instructions-swiper-root]',
      previousButton: '[data-brewing-instructions-previous]',
      nextButton: '[data-brewing-instructions-next]',
      paginationContainer: '[data-brewing-instructions-pagination]',
      productTitleTargets: '[data-brewing-instructions-product-title]',
    },
    watchResize: true,
    getSwiperOptions({
      sliderElement,
      swiperContainerElement,
      previousButtonElement,
      nextButtonElement,
      paginationContainerElement,
      spaceBetweenSlides,
      transitionSpeed,
    }) {
      return {
        slidesPerView: 1,
        spaceBetween: spaceBetweenSlides,
        speed: transitionSpeed,
        watchOverflow: true,
        nested: true,
        navigation: {
          prevEl: previousButtonElement,
          nextEl: nextButtonElement,
        },
        pagination: {
          el: paginationContainerElement,
          clickable: true,
          renderBullet: (index, className) =>
            `<button type="button" class="brewing-instructions__dot ${className}"></button>`,
        },
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { enabled: true },
      };
    },
    onUpdate({ sliderElement, swiperInstance }) {
      const activeSlideElement = swiperInstance?.slides?.[swiperInstance.activeIndex];
      const productTitle = activeSlideElement?.dataset?.productTitle || '';

      sliderElement.querySelectorAll('[data-brewing-instructions-product-title]').forEach((el) => {
        el.textContent = productTitle;
      });

      window.dispatchEvent(new Event('resize'));
    },
  });
})();
